export default "__VITE_ASSET__478dc62e__"